<template>
  <div class="standart-table">
    <table border="1" :style="{ width: `${tableWidth}px` }">
      <!--  -->
      <tr>
        <th rowspan="14" class="table-title">
          {{ getProcessName(props.title) }}
        </th>
        <th :colspan="passRateList.length + 1">数量统计</th>
      </tr>

      <tr>
        <th rowspan="2">今日送检数量</th>

        <template v-for="(item, index) in passRateList" :key="index">
          <th>{{ item.name }}</th>
        </template>
        <!-- 
        <td>总计</td>

        <td>swan 600</td>
        <td>swan 600P</td> -->
      </tr>

      <tr>
        <template v-for="(item, index) in passRateList" :key="index">
          <td>{{ item.data.count }}</td>
        </template>
      </tr>

      <tr>
        <th class="text">一次送检数量</th>
        <template v-for="(item, index) in passRateList" :key="index">
          <td>{{ item.data.onceSubmissionNum }}</td>
        </template>
      </tr>

      <tr>
        <th class="text">一次合格数量</th>
        <template v-for="(item, index) in passRateList" :key="index">
          <td>{{ item.data.onceQualifiedNum }}</td>
        </template>
      </tr>

      <tr>
        <th class="text">一次合格率</th>
        <template v-for="(item, index) in passRateList" :key="index">
          <td>{{ item.data.onceRate }}</td>
        </template>
      </tr>

      <tr>
        <th class="text">二次送检数量</th>
        <template v-for="(item, index) in passRateList" :key="index">
          <td>{{ item.data.secondSubmissionNum }}</td>
        </template>
      </tr>

      <tr>
        <th class="text">二次合格数量</th>
        <template v-for="(item, index) in passRateList" :key="index">
          <td>{{ item.data.secondQualifiedNum }}</td>
        </template>
      </tr>

      <tr>
        <th class="text">二次合格率</th>
        <template v-for="(item, index) in passRateList" :key="index">
          <td>{{ item.data.secondRate }}</td>
        </template>
      </tr>

      <tr>
        <th class="text">三次送检数量</th>
        <template v-for="(item, index) in passRateList" :key="index">
          <td>{{ item.data.geThriceSubmissionNum }}</td>
        </template>
      </tr>

      <tr>
        <th class="text">三次合格数量</th>
        <template v-for="(item, index) in passRateList" :key="index">
          <td>{{ item.data.geThriceQualifiedNum }}</td>
        </template>
      </tr>

      <tr>
        <th class="text">三次合格率</th>
        <template v-for="(item, index) in passRateList" :key="index">
          <td>{{ item.data.geThriceRate }}</td>
        </template>
      </tr>
      <tr>
        <th class="text">退回未送检数量</th>
        <template v-for="(item, index) in passRateList" :key="index">
          <td>{{ item.data.returnedNum }}</td>
        </template>
      </tr>

      <tr>
        <th class="text">拖延率</th>
        <template v-for="(item, index) in passRateList" :key="index">
          <td>{{ item.data.returnedRate }}</td>
        </template>
      </tr>

      <!-- <template v-for="(item, index) in passRateList" :key="index">
        <tr>
          <td v-if="index !== 0" class="text">{{ item.text }}</td>
          <td class="total">{{ item.total }}</td>
          <td>{{ item.swan600 }}</td>
          <td>{{ item.swan600P }}</td>
        </tr>
      </template> -->
    </table>
  </div>
</template>

<script>
import { computed, defineComponent, reactive, watch } from "vue";
import { getProcessName } from "@/views/productDaily/serve/option";

export default defineComponent({
  props: {
    passRateData: Object,
    title: String,
  },
  setup(props, content) {
    const passRateList = reactive([]);

    const tableWidth = computed(() => (passRateList.length * 80) + 300);

    watch(
      () => props.passRateData,
      (val) => {
        passRateList.length = 0;
        passRateList.push(...val);
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      getProcessName,
      tableWidth,
      passRateList,
      props,
    };
  },
});
</script>

<style lang="less" scoped>
.standart-table {
  font-size: 16px;
  margin-bottom: 16px;
  width: 475px;
  overflow-x: scroll;
  th {
    text-align: center;
  }
  td {
    padding: 5px;
    text-align: center;
  }
  tr:nth-child(2n - 1) {
    background: #ccc;
  }
  .text {
    width: 140px;
  }
  .total {
    width: 80px;
  }

}
</style>
